"use client";

import { useState } from "react";
import { Button } from "../ui/button";
import { ResponsiveModal } from "../ui/responsive-modal";
import { Typography } from "../ui/typography";
import { AmenityItem } from "./AmenityItem";
import { Amenity } from "@/types/amenity";

export const AccommodationAllAmenitiesDialog: React.FC<{
  allAmenities: Amenity[];
}> = ({ allAmenities }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant="secondary"
        className="w-full md:w-auto md:px-12 h-10 bg-gray-50 text-foreground rounded-lg hover:bg-gray-100 transition-colors"
        onClick={handleOpenModal}
      >
        مشاهده همه امکانات
      </Button>
      <ResponsiveModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        // title="تمام امکانات ویلا"
        direction="bottom"
        className="pt-4"
      >
        <div className="px-6 md:px-8 py-4 space-y-6">
          <div className="space-y-4">
            <Typography
              variant="bodySMedium"
              className="hidden md:block pt-8 pb-6 text-lg"
            >
              امکانات و ویژگی ها
            </Typography>
            <Typography
              variant="bodySMedium"
              className="md:hidden text-center border-b pb-2"
            >
              امکانات رفاهی
            </Typography>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-x-6 md:gap-y-7 overflow-y-auto max-h-[60vh]">
              {allAmenities?.map((amenity, index) => (
                <AmenityItem
                  key={`${amenity.slug}-${index}`}
                  amenity={amenity}
                />
              ))}
            </div>
          </div>
        </div>
      </ResponsiveModal>
    </>
  );
};
